import { render, staticRenderFns } from "./ui-input.vue?vue&type=template&id=9510fb84&"
import script from "./ui-input.vue?vue&type=script&lang=js&"
export * from "./ui-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports